import { useEffect, useMemo } from "react";
import BaseLayout from "../../layouts/BaseLayout";
import { useParams } from "react-router-dom";
import { apiRequest, VojomoLoader } from "@vojomo-core/shared";
import { useState } from "react";
import { Button, Checkbox, Input, Select, Tooltip } from "antd";

export const AgentDtls = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const [version, setVersion] = useState("Latest");

  const [baseData, setBaseData] = useState<any>({});

  const [agentData, setAgentData] = useState<any>({});
  const [prodAgentData, setProdAgentData] = useState<any>({});

  const agentName = baseData.label;
  const agentUrl = baseData.url;
  const agentFolder =
    version === "Latest"
      ? agentData.full_folder_path
      : prodAgentData.full_folder_path;

  const getSystemPrompt = () => {
    let data = agentData;
    if (version === "Production") {
      data = prodAgentData;
    }

    if (!data || !data.prompt_info) {
      return "";
    }

    console.log(data.prompt_info.prompt_template.content);

    if (
      data.prompt_info.prompt_template &&
      "messages" in data.prompt_info.prompt_template
    ) {
      return data.prompt_info.prompt_template.messages[0]?.content[0]?.text;
    } else if (data.prompt_info.prompt_template.content) {
      return data.prompt_info.prompt_template.content[0]?.text;
    } else {
      return "";
    }
  };

  const agentSystemPrompt = getSystemPrompt();
  const agentAvailableToModus =
    version === "Latest"
      ? (agentData.prompt_info?.metadata?.modus_useable || "false")
          .toString()
          .toLowerCase() === "true" ||
        agentData.prompt_info?.metadata?.modus_useable === true
      : (prodAgentData.prompt_info?.metadata?.modus_useable || "false")
          .toString()
          .toLowerCase() === "true" ||
        prodAgentData.prompt_info?.metadata?.modus_useable === true;

  const [updatedSystemPrompt, setUpdatedSystemPrompt] = useState<string | null>(
    null
  );
  const [updatedAvailableToModus, setUpdatedAvailableToModus] = useState<
    boolean | null
  >(null);

  const isLatestProd =
    agentData?.prompt_info?.version == prodAgentData?.prompt_info?.version;

  const fetchData = async () => {
    const baseData: any = await apiRequest({
      subRoute: "admin",
      path: `/get_pl_data_dict?prompt_id=${id}`,
      method: "GET"
    });
    setBaseData(baseData.dataSource[0]);

    const data = await apiRequest({
      subRoute: "ai",
      path: `/get_prompt_info?prompt_name=${baseData.dataSource[0].label}&prod=false`,
      method: "GET"
    });
    setAgentData(data);

    const prodData = await apiRequest({
      subRoute: "ai",
      path: `/get_prompt_info?prompt_name=${baseData.dataSource[0].label}&prod=true`,
      method: "GET"
    });

    setProdAgentData(prodData);
    setUpdatedSystemPrompt(null);
    setLoading(false);
  };

  const createNewVersion = async () => {
    await apiRequest({
      subRoute: "admin",
      path: "/update_pl_prompt",
      method: "PATCH",
      body: {
        prompt_name: agentName,
        // available_tools: updatedAvailableToModus,
        available_to_modus:
          updatedAvailableToModus == null
            ? agentAvailableToModus
            : updatedAvailableToModus,
        system_prompt: updatedSystemPrompt || agentSystemPrompt
      }
    });
  };

  const showUpdateButton = useMemo(() => {
    return (
      version === "Latest" &&
      ((updatedSystemPrompt !== agentSystemPrompt &&
        updatedSystemPrompt !== null) ||
        (updatedAvailableToModus !== agentAvailableToModus &&
          updatedAvailableToModus !== null))
    );
  }, [
    updatedSystemPrompt,
    agentSystemPrompt,
    updatedAvailableToModus,
    agentAvailableToModus,
    version
  ]);

  useEffect(() => {
    fetchData();
  }, []);

  console.log("UPDATED AVAILABLE TO MODUS", updatedAvailableToModus);
  console.log("AGENT AVAILABLE TO MODUS", agentAvailableToModus);

  const showAvailableToModus = false; // placeholder to keep the button available if we want to go back to it

  return (
    <BaseLayout pageTitle={`${agentName} Details`}>
      {loading ? (
        <VojomoLoader />
      ) : (
        <div>
          <h3>{agentName} Details</h3>
          <div
            style={{
              maxHeight: "75vh",
              overflowY: "scroll",
              paddingRight: "20px"
            }}
          >
            <Select
              showSearch
              defaultValue={"Latest"}
              onChange={(e) => {
                setVersion(e);
              }}
              options={[
                { value: "Latest", label: "Latest" },
                { value: "Production", label: "Production" }
              ]}
              style={{ width: "200px" }}
            />
            <p>
              {isLatestProd && (
                <>
                  <b>Latest version is production</b>
                  <br />
                  <br />
                </>
              )}
              <b>Folder:</b> {agentFolder || "None"}
              <br />
              <br />
              <b>System Prompt:</b>{" "}
              {version === "Latest" ? (
                <Input.TextArea
                  value={updatedSystemPrompt || agentSystemPrompt}
                  onChange={(e) => {
                    setUpdatedSystemPrompt(e.target.value);
                  }}
                  style={{ marginTop: "10px" }}
                  rows={10}
                />
              ) : (
                <p>{agentSystemPrompt}</p>
              )}
              <br />
              <br />
              {showAvailableToModus && (
                <>
                  <b>Available to Modus:</b>{" "}
                  <Checkbox
                    disabled={version === "Production"}
                    checked={
                      updatedAvailableToModus == null
                        ? agentAvailableToModus
                        : updatedAvailableToModus
                    }
                    onChange={(e) => {
                      setUpdatedAvailableToModus(e.target.checked);
                    }}
                  />
                  <br />
                  <br />
                </>
              )}
              <b>
                <a
                  style={{ color: "blue" }}
                  href={agentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Promptlayer link
                </a>
              </b>
            </p>
            {showUpdateButton && (
              <Tooltip
                placement="right"
                title="Updating the agent will create a new version of the system prompt / available to Modus and will be active in sandbox"
              >
                <Button
                  loading={updating}
                  style={{ marginBottom: "10px" }}
                  onClick={async () => {
                    setUpdating(true);
                    // create new version
                    await createNewVersion();
                    await fetchData();
                    setUpdating(false);
                  }}
                >
                  Update agent
                </Button>
              </Tooltip>
            )}
            {/* TODO: Add promote to production button */}
            {/* {!isLatestProd && version === "Latest" && !showUpdateButton && (
              <>
                <Tooltip
                  placement="right"
                  title="This will promote the latest version of the system prompt to production"
                >
                  <Button
                    onClick={() => {
                      // update prod label to latest version
                    }}
                  >
                    Promote to production
                  </Button>
                </Tooltip>
              </>
            )} */}
          </div>
        </div>
      )}
    </BaseLayout>
  );
};
